import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { ApiSurface } from './login.js';
import { useAuth } from './AuthProvider.js';
import { isPublicPath } from './routes.js';
import { authPathWithReturn, locationToReturnPath } from './returnPath.js';

export interface RequireAuthProps {
  surface: ApiSurface;
}

export function RequireAuth({ surface }: RequireAuthProps) {
  const { authenticated, bootstrapping, signInPath } = useAuth();
  const location = useLocation();

  if (isPublicPath(surface, location.pathname)) {
    return <Outlet />;
  }

  if (bootstrapping) {
    return <p aria-busy="true">Checking session…</p>;
  }

  if (!authenticated) {
    const returnTo = locationToReturnPath(location.pathname, location.search);
    return (
      <Navigate
        to={authPathWithReturn(signInPath, returnTo)}
        replace
        state={{ from: returnTo }}
      />
    );
  }

  return <Outlet />;
}
